(function(){
  // ---- Planting-label modal (reads data-label-src from variety links) ----
  var lm=document.getElementById('lm');
  if(lm){
    var img=document.getElementById('lmi'),nm=document.getElementById('lmn'),dl=document.getElementById('lmdl');
    function open(src,name){
      if(!src)return;
      img.src=src; img.classList.remove('zoom');
      if(nm)nm.textContent=name||'';
      if(dl){dl.href=src; dl.download=(name||'label').replace(/ /g,'_')+'_label.png';}
      lm.classList.add('open');
    }
    function close(){lm.classList.remove('open');}
    document.querySelectorAll('[data-label-src]').forEach(function(el){
      el.addEventListener('click',function(e){e.preventDefault();open(el.getAttribute('data-label-src'),el.getAttribute('data-label-name'));});
    });
    var x=document.getElementById('lmx'),bg=document.getElementById('lmbg');
    if(x)x.onclick=close; if(bg)bg.onclick=close;
    if(img)img.onclick=function(){this.classList.toggle('zoom');};
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  }
  // ---- variety multi-select chips ----
  document.querySelectorAll('#ch .chip').forEach(function(c){
    c.onclick=function(){c.classList.toggle('on');var ch=document.getElementById('ch');if(ch)ch.classList.remove('chips-error');};
  });
  // ---- trial request form -> Shopify free checkout (fallback: mailto) ----
  var qf=document.getElementById('qf');
  if(qf){
    qf.addEventListener('submit',function(e){
      e.preventDefault();
      var f=qf;
      var ag=document.getElementById('ag');
      // feedback is required for the trial (so we can follow up)
      if(ag && !ag.checked){ ag.focus(); alert('Please confirm you can share brief feedback — it lets us follow up on how your trial is going.'); return; }
      var feedback = true;
      var g=function(n){var el=f.elements[n];return el&&el.value?el.value.trim():'';};
      var m=(f.querySelector('input[name=method]:checked')||{}).value||'';
      var chips=Array.prototype.slice.call(document.querySelectorAll('#ch .chip.on'));
      // require at least one variety selected
      if(chips.length===0){
        var chbox=document.getElementById('ch');
        if(chbox){ chbox.classList.add('chips-error'); chbox.scrollIntoView({behavior:'smooth',block:'center'}); }
        alert('Please select at least one variety to trial.');
        return;
      }
      var titles=chips.map(function(c){return c.getAttribute('data-title')||c.getAttribute('data-v');});
      var first=g('first_name'),last=g('last_name'),name=(first+' '+last).replace(/\s+/g,' ').trim();
      var email=g('email'),biz=g('business'),phone=g('phone');
      var addr=g('address'),city=g('city'),prov=g('province'),zip=g('zip');

      var useCheckout = f.getAttribute('data-checkout')==='true'
                     && f.getAttribute('data-has-variants')==='true';
      var variantChips = chips.filter(function(c){return c.getAttribute('data-variant-id');});

      // build shared grower details (also used as mailto body)
      var details=['Name: '+name,'Farm: '+biz,'Phone: '+phone,'Email: '+email,
        'Mailing address: '+[addr,city,prov,zip].filter(Boolean).join(', '),
        'Varieties: '+(titles.join(', ')||'(none)'),
        'Space: '+g('space'),'Timeframe: '+g('timeframe'),'Method: '+m,'Will share feedback: '+(feedback?'Yes':'No')];

      function mailtoFallback(){
        var to=f.getAttribute('data-email')||'harvestgoalsllc@gmail.com';
        window.location.href='mailto:'+to+'?subject='+encodeURIComponent('Trial request - '+name)
          +'&body='+encodeURIComponent(details.join(String.fromCharCode(10)));
      }

      if(!useCheckout || variantChips.length===0){ mailtoFallback(); return; }

      // ----- build cart then send to a $0 checkout with address prefilled -----
      var qty=parseInt(f.getAttribute('data-qty'),10)||1;
      var props={ "Grower":name, "Farm":biz, "Phone":phone };
      var items=variantChips.map(function(c){
        return { id: c.getAttribute('data-variant-id'), quantity: qty, properties: props };
      });
      var attributes={
        "Grower name":name, "Farm":biz, "Phone":phone, "Email":email,
        "Mailing address":[addr,city,prov,zip].filter(Boolean).join(', '),
        "Growing space":g('space'), "Planting timeframe":g('timeframe'),
        "Growing method":m, "Feedback agreed":(feedback?'Yes':'No'), "Trial varieties":titles.join(', '),
        // structured fields (used to prefill the cart + checkout)
        "_first":first, "_last":last, "_address1":addr, "_city":city, "_province":prov, "_zip":zip
      };

      var btn=f.querySelector('button[type=submit]'); if(btn){btn.disabled=true;btn.textContent='Preparing your free checkout…';}

      var J={'Content-Type':'application/json'};
      fetch('/cart/clear.js',{method:'POST',headers:J})
        .then(function(){return fetch('/cart/add.js',{method:'POST',headers:J,body:JSON.stringify({items:items})});})
        .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function(){return fetch('/cart/update.js',{method:'POST',headers:J,body:JSON.stringify({note:'Free trial request via website',attributes:attributes})});})
        .then(function(){
          // prefill checkout (values encoded; keys kept literal)
          var parts=[];
          function add(k,v){ if(v) parts.push(k+'='+encodeURIComponent(v)); }
          add('checkout[email]',email);
          add('checkout[shipping_address][first_name]',first);
          add('checkout[shipping_address][last_name]',last);
          add('checkout[shipping_address][address1]',addr);
          add('checkout[shipping_address][city]',city);
          add('checkout[shipping_address][province]',prov);
          add('checkout[shipping_address][zip]',zip);
          add('checkout[shipping_address][country]','United States');
          add('checkout[shipping_address][phone]',phone);
          var url='/checkout'+(parts.length?('?'+parts.join('&')):'');
          var code=f.getAttribute('data-discount');
          if(code){ url='/discount/'+encodeURIComponent(code)+'?redirect='+encodeURIComponent(url); }
          window.location.href=url;
        })
        .catch(function(){ if(btn){btn.disabled=false;btn.textContent='Continue to free checkout →';} mailtoFallback(); });
    });
  }
})();
